import { onDomReady } from '../utils/dom';

/*
 * Videos mit Bedienelementen (Player-Element ohne Autoplay, z. B. die Produktfilme auf den Produktseiten):
 * Die native Steuerleiste sieht in jedem Browser anders aus und passt nicht zum Design. Deshalb wird sie
 * beim Laden entfernt und durch einen Play-Button im Stil der Website über dem Posterbild ersetzt.
 * Erst mit dem Start bekommt das Video seine nativen Bedienelemente zurück (Pause, Lautstärke, Vollbild).
 * Ohne JavaScript bleibt das Video mit nativer Steuerleiste bedienbar, weil das controls-Attribut
 * serverseitig gesetzt ist.
 */

// Autoplay-Videos (3D-Animation) bleiben außen vor, die steuert autoplayVideo.js
const SELECTOR = '.content-player video[controls]:not([autoplay])';
const LABELS = { de: 'Video abspielen', en: 'Play video' };

function playLabel() {
    const language = document.documentElement.lang.slice(0, 2);

    return LABELS[language] ?? LABELS.en;
}

function createButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'video-play-button';

    // Der Button füllt die ganze Videofläche, sichtbar gestaltet ist nur der innere span
    const label = document.createElement('span');
    label.textContent = playLabel();
    button.append(label);

    return button;
}

function start(video, button) {
    video.controls = true;
    // play() kann abgelehnt werden (z. B. Datensparmodus); die nativen Bedienelemente sind dann trotzdem da
    video.play().catch(() => {});
    // Tastaturnutzer landen direkt auf dem Video und damit auf den nativen Bedienelementen
    video.focus({ preventScroll: true });
    button.hide().then(() => button.remove());
}

function enhance(video) {
    video.removeAttribute('controls');

    const button = createButton();
    button.addEventListener('click', () => start(video, button), { once: true });
    video.after(button);
}

onDomReady(() => {
    for (const video of document.querySelectorAll(SELECTOR)) {
        enhance(video);
    }
});
